/* TO BE REMOVED */
export const FETCH_MORE_COURSE_TEMPLATES = "FETCH_MORE_COURSE_TEMPLATES";
export const QUERY_COURSE_TEMPLATE = "QUERY_COURSE_TEMPLATE";
export const CLEAR_COURSE_TEMPLATE_FILTERS = "CLEAR_COURSE_TEMPLATE_FILTERS";
export const SET_COURSE_TEMPLATES_FILTERS_CLEAR = "SET_COURSE_TEMPLATES_FILTERS_CLEAR";
export const SET_COURSE_TEMPLATE_QUERY = "SET_COURSE_TEMPLATE_QUERY";

/* TO BE REFACTOR */

export const SET_COURSE_TEMPLATE = "SET_COURSE_TEMPLATE";
export const SET_COURSE_TEMPLATE_SESSIONS = "SET_COURSE_TEMPLATE_SESSIONS";
export const SET_COURSE_TEMPLATES_BY_TYPE = "SET_COURSE_TEMPLATE_BY_TYPE";

export const HANDLE_FETCH_ALL_COURSE_TEMPLATES = "HANDLE_FETCH_ALL_COURSE_TEMPLATES";

export interface IHandleFetchAllCourseTemples {
  type: typeof HANDLE_FETCH_ALL_COURSE_TEMPLATES;
}

export const SET_COURSE_TEMPLATE_LOADER = "SET_COURSE_TEMPLATE_LOADER";

export interface ISetCourseTemplateLoader {
  type: typeof SET_COURSE_TEMPLATE_LOADER;
  payload: boolean;
}

export const HANDLE_APPLY_TEMPLATE_TO_STUDENT = "HANDLE_APPLY_TEMPLATE_TO_STUDENT";

export interface IHandleApplyTemplateToStudent {
  type: typeof HANDLE_APPLY_TEMPLATE_TO_STUDENT;
  payload: ApplyTemplateRequest;
}

export const HANDLE_APPLY_TEMPLATE_TO_CLASS = "HANDLE_APPLY_TEMPLATE_TO_CLASS";

export interface IHandleApplyTemplateToClass {
  type: typeof HANDLE_APPLY_TEMPLATE_TO_CLASS;
  payload: ApplyTemplateRequest;
}

export const HANDLE_FETCH_SELECTED_COURSE_TEMPLATE = "HANDLE_FETCH_SELECTED_COURSE_TEMPLATE";

export interface IHandleFetchSelectedCourseTemplate {
  type: typeof HANDLE_FETCH_SELECTED_COURSE_TEMPLATE;
  payload: string;
}

export const SET_SELECTED_COURSE_TEMPLATE = "SET_SELECTED_COURSE_TEMPLATE";

export interface ISetSelectedCourseTemplate {
  type: typeof SET_SELECTED_COURSE_TEMPLATE;
  payload: CourseTemplate;
}

export const GET_COURSE_TEMPLATE_SESSIONS = "GET_COURSE_TEMPLATE_SESSIONS";

export const HANDLE_DELETE_COURSE_TEMPLATES = "HANDLE_DELETE_COURSE_TEMPLATES";
export interface IHandleDeleteCourseTemplates {
  type: typeof HANDLE_DELETE_COURSE_TEMPLATES;
  payload: {
    courseTemplatesIds: string[];
  };
}

export const HANDLE_CREATE_COURSE_TEMPLATE = "HANDLE_CREATE_COURSE_TEMPLATE";
export interface IHandleCreateCourseTemplate {
  type: typeof HANDLE_CREATE_COURSE_TEMPLATE;
  payload: {
    courseTemplate: CourseTemplate;
    fromCalendar: boolean;
    classroomTemplate: boolean;
  };
}

export const HANDLE_UPDATE_COURSE_TEMPLATE = "HANDLE_UPDATE_COURSE_TEMPLATE";
export interface IHandleUpdateCourseTemplate {
  type: typeof HANDLE_UPDATE_COURSE_TEMPLATE;
  payload: {
    courseTemplate: CourseTemplate;
  };
}
